import React, { useRef } from 'react'
import { Container, Text, Link, Picture, Button } from '../../components/index.js'
import CompanyStatsBanner from './CompanyStatsBanner/index.js'
import { cn, getLocalizedPath } from '../../helpers/utils.js'
import { useAiuiContext } from '../AiuiProvider/index.js'

/**
 * 多列下拉
 * @param categoriesItem 分类项
 */
export const MulticolDropdown = ({
  multicolMetadata,
  showStatsBanner,
  statsBannerData,
}: {
  multicolMetadata: any
  showStatsBanner: boolean
  statsBannerData: any
}) => {
  const multicolDropdownRef = useRef<HTMLDivElement>(null)

  return (
    <div ref={multicolDropdownRef} className="bg-white py-4">
      <Container childClassName="bg-white" className="h-full">
        <div className="laptop:gap-4 flex flex-col gap-3">
          {showStatsBanner && <CompanyStatsBanner data={statsBannerData} />}
          <div className="flex gap-4">
            {multicolMetadata?.map((item: any, index: number) => (
              <div key={`multicolItem-${item?.label}-${index}`} className="w-1/4">
                <MulticolItem item={item} />
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}

/**
 * 多列下拉项
 * @param item 多列下拉项
 */
export const MulticolItem = ({ item, allPicture }: { item: any; allPicture?: boolean }) => {
  const { locale = 'us' } = useAiuiContext()
  return (
    <>
      {item?.columns && (
        <>
          <Text html={item.label} as="div" className="my-2 text-sm font-bold leading-[1.4] text-[#6D6D6F]" />
          <div className="mt-2 flex flex-col">
            {item.columns?.map((columnItem: any) => (
              <div key={columnItem.label} className="flex items-center gap-1 py-2">
                <Link
                  href={`${getLocalizedPath(columnItem.url, locale)}?ref=navMenu`}
                  asChild={!columnItem.url}
                  className="text-sm font-bold leading-[1.4] no-underline"
                >
                  {columnItem.label}
                </Link>
                {columnItem?.badge && (
                  <Text
                    as="p"
                    html={columnItem?.badge || 'badge'}
                    className="text-brand-0 h-[24px] rounded-full border-[1.6px] border-[var(--brand-color-0)] px-[6px] text-sm font-bold !leading-[22px]"
                  />
                )}
              </div>
            ))}
          </div>
        </>
      )}
      {item?.imageUrl && (
        <div
          className={cn(
            'rounded-image-text laptop:h-[280px] desktop:h-[224px] lg-desktop:h-[280px] tablet:max-w-[346px] laptop:max-w-[440px] desktop:w-full relative h-[240px] max-w-[358px] overflow-hidden',
            {
              ['tablet:max-w-none laptop:max-w-none']: allPicture,
            }
          )}
        >
          <Link href={`${getLocalizedPath(item.url, locale)}?ref=navMenu`} asChild={!item.url}>
            <Picture
              source={item.imageUrl}
              width={404}
              height={280}
              className="size-full"
              imgClassName="object-cover h-full hover:scale-105 transition-all duration-300"
            />
            <div className="absolute bottom-4 left-4 z-10 flex flex-col justify-end no-underline">
              <Text
                html={item.title}
                className={cn('lg-desktop:text-2xl text-xl font-bold leading-[1.2] text-white', {
                  'text-black': item?.theme === 'dark',
                })}
              />
              {item.subtitle && (
                <Text
                  html={item.subtitle}
                  className={cn('text-sm font-bold leading-[1.4] text-white', {
                    'text-black': item?.theme === 'dark',
                  })}
                />
              )}
              {item?.primary?.label && (
                <Button
                  as="a"
                  href={getLocalizedPath(item?.primary?.url, locale)}
                  variant="link"
                  size="lg"
                  iconClassName="size-4 lg-desktop:size-5"
                  className={cn('mr-auto !p-0 text-sm font-bold leading-[1.4] text-white', {
                    'text-black': item?.theme === 'dark',
                  })}
                >
                  {item?.primary?.label || 'more'}
                </Button>
              )}
            </div>
          </Link>
        </div>
      )}
    </>
  )
}
